// extracted by mini-css-extract-plugin
export default {"secondContainer":"Contact_secondContainer__S+0QW","secondHeading":"Contact_secondHeading__AjTc8"};